import { useMemo, type FunctionComponent } from 'react';
import { useInfo, useToken } from '../../../Flow/ConsentContextProvider';
import ConsentDetails, { type DetailEntry } from '../../shared/agent-consent/Details/Details';
import { mcpDetailsMessages } from './messages';

/**
 * MCP-specific details component.
 * Renders Name and Domains rows.
 */
const McpDetails: FunctionComponent = () => {
  const { clientName, redirectUrl } = useToken();
  const { client } = useInfo();

  const redirectUrls = useMemo(() => {
    const seen = new Set<string>();
    const urls: string[] = [];
    const add = (u: string | undefined | null) => {
      const t = u?.trim();
      if (t && !seen.has(t)) {
        seen.add(t);
        urls.push(t);
      }
    };
    add(redirectUrl?.callback);
    (client?.callbacks ?? []).forEach(add);
    return urls;
  }, [redirectUrl, client?.callbacks]);

  const entries: DetailEntry[] = [
    { label: mcpDetailsMessages.nameLabel, value: clientName ?? '' },
    ...(redirectUrls.length > 0
      ? [{ label: mcpDetailsMessages.domainLabel, value: redirectUrls }]
      : []),
  ];

  return (
    <ConsentDetails
      title={mcpDetailsMessages.detailsTitle}
      entries={entries}
    />
  );
};

export default McpDetails;
